import { useReducer, Dispatch, Reducer } from 'react';

import produce, { Draft } from 'immer';

import { Action } from './constants';
import { StateType, ActionType } from './types';

export const initialState: StateType = {
  callRescueTests: [],
  totalCount: 0,
  currentPage: 1,
  search: '',
  callRescueStatusFilter: [],
};

const reducer: Reducer<StateType, ActionType> = produce(
  (draft: Draft<StateType>, action: ActionType) => {
    const { type } = action;
    switch (type) {
      case Action.SET_CALL_RESCUE_MONITOR: {
        if (!('callRescueTests' in action)) throw new Error('Call rescue tests are missing');
        draft.callRescueTests = action.callRescueTests;
        draft.totalCount = action.totalCount;
        break;
      }
      case Action.SET_PAGE: {
        if (!('page' in action)) throw new Error('Page is missing');
        const { page } = action;
        draft.currentPage = page;
        break;
      }
      case Action.SET_SEARCH: {
        if (!('search' in action)) throw new Error('Search is missing');
        const { search, currentPage } = action;
        draft.search = search;
        if (currentPage) {
          draft.currentPage = currentPage;
        }
        break;
      }
      case Action.SET_CALL_RESCUE_STATUS_FILTER: {
        if (!('callRescueStatus' in action)) throw new Error('callRescueStatus is missing');
        const { callRescueStatus } = action;
        const statusIndex = draft.callRescueStatusFilter.indexOf(callRescueStatus);
        if (statusIndex >= 0) {
          draft.callRescueStatusFilter.splice(statusIndex, 1);
          break;
        }
        draft.callRescueStatusFilter.push(callRescueStatus);
        break;
      }
      default:
        throw new Error();
    }
  },
  initialState
);

export const useCallRescueMonitorReducer = (): [StateType, Dispatch<ActionType>] =>
  useReducer(reducer, initialState);

export default reducer;
